import apiClient from './client';
import { AuthResponse, LoginRequest, RegisterRequest, User } from '../../shared/types';

export const authApi = {
  /**
   * Register a new user
   */
  async register(email: string, password: string): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/register', {
      email,
      password,
    } as RegisterRequest);
    return response.data;
  },

  /**
   * Login an existing user
   */
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/login', {
      email,
      password,
    } as LoginRequest);
    return response.data;
  },

  /**
   * Get current user
   */
  async me(): Promise<{ user: User }> {
    const response = await apiClient.get<{ user: User }>('/auth/me');
    return response.data;
  },

  /**
   * Logout (client-side only)
   */
  logout(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
  },
};
